import {Component, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {LightPortal} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-light-portal-inspector",
    templateUrl: "./light-portal-inspector.component.html",
    styleUrl: "./light-portal-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class LightPortalInspectorComponent extends BaseInspectorComponent<LightPortal> {}
